import { render, staticRenderFns } from "./ItemRelationsDataTable.vue?vue&type=template&id=7843ee8b"
import script from "./ItemRelationsDataTable.vue?vue&type=script&lang=js"
export * from "./ItemRelationsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports